"use client";

import { contentfulImageLoader } from "@utils/imageLoader";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";

import Image from "@/components/ui/Image/Image";

import Kpi50 from "./Kpi50";
import { EditorialKpi, EditorialModuleImage as EditorialModuleImageType } from "./type";

export interface EditorialModuleImageProps {
  entry: EditorialModuleImageType;
  kpi?: EditorialKpi[];
  slideIndex?: number;
}

export default function EditorialModuleImage({ entry, kpi }: EditorialModuleImageProps) {
  const [isSo, setIsSo] = useState<boolean>(false);
  const locale = useLocale();
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = localStorage?.getItem("isSo");
      if (value) {
        setIsSo(value === "true");
      }
    }
  }, []);

  const isHomePage = pathname === "/" || pathname === `/${locale}/`;
  if (isSo) {
    return null;
  }
  return (
    <div className="relative h-full">
      <img
        className="absolute right-0 mt-m mr-m md:w-[110px] md:mt-xl md:mr-[40px] z-10"
        src="/assets/damac-d.svg"
        width={76}
        height={46}
        alt="logo damac"
      />
      <div className="relative">
        <img
          className="aspect-1-1 md:aspect-auto object-cover w-full h-full md:block"
          src={contentfulImageLoader({ src: entry.image.url, width: 750, quality: 80 })}
          srcSet={[375, 750, 960, 1280].map((w) => `${contentfulImageLoader({ src: entry.image.url, width: w, quality: 80 })} ${w}w`).join(", ")}
          sizes="(min-width: 1024px) 50vw, 100vw"
          alt={entry.image.title}
          loading="lazy"
          decoding="async"
        />
        <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-2 md:hidden"></div>
      </div>
      {kpi && <Kpi50 kpi={kpi} />}
    </div>
  );
}
